import React from "react";
import InfoIconFacility from "../InfoIconFacilities";
import { useTranslation } from "react-i18next";
import TipBox from "../../../../components/TipBox";

const DropdownWithInput = ({
  label,
  options,
  valueDropdown,
  onChangeDropdown,
  isEditing,
  valueInput,
  onChangeInput,
  customStyle,
  isDisabled,
  errorMessage,
}) => {
  const { t } = useTranslation();
  const renderSelectWithTooltip = () => (
    <TipBox
      title={label}
      message={options.find((opt) => opt.value === valueDropdown)?.name || ""}
    >
      <select
        value={valueDropdown}
        onChange={(e) => onChangeDropdown(e.target.value)}
        disabled={!isEditing}
      >
        <option value="">Select {label}</option>
        {options.map((option) => (
          <option key={option.id} value={option.value}>
            {option.name}
          </option>
        ))}
      </select>
    </TipBox>
  );
  return (
    <div className="dropdown-field" style={customStyle}>
      <div className="info-facility-tip">
        <InfoIconFacility text={t("OWNERSHIP_TIP_BOX")} />
      </div>
      <label>{label}</label>
      <div
        className="bg-dropdown-input"
        style={{ display: "flex", alignItems: "center" }}
      >
        {renderSelectWithTooltip()}

        <input
          type="text"
          value={valueInput}
          onChange={(e) => onChangeInput(e.target.value)}
          disabled={isDisabled || !isEditing}
          placeholder="%"
        />

        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </div>
      <span
        style={{
          color: "rgba(44, 91, 71, 0.6)",
          fontSize: "12px",
        }}
      >
        %
      </span>
    </div>
  );
};

export default DropdownWithInput;
